import type { PublicBookingCreateResponse } from "./api";

type PreShootNote = NonNullable<PublicBookingCreateResponse["preShootNotes"]>[number];

/**
 * Khối "Trước buổi chụp cần biết" — những điều khách cần biết, hiện SAU khi
 * tiền cọc đã về (CEO chốt 27/08/2026).
 *
 * Chữ nghĩa do máy chủ dựng (`preShootNotes`), không viết ở đây: cùng danh
 * sách ấy còn đi vào thư điện tử, hai nơi chép tay là hai nơi lệch nhau.
 *
 * Danh sách rỗng thì không vẽ gì — một cái khung trống còn tệ hơn là không có.
 */
export function PreShootNotesCard({ notes }: { notes: PreShootNote[] | undefined }) {
  if (!notes || notes.length === 0) return null;

  return (
    <section className="mt-6 rounded-2xl bg-surface-2 p-4">
      <h2 className="text-base font-semibold">Trước buổi chụp cần biết</h2>
      <dl className="mt-3 space-y-3">
        {notes.map((note) => (
          <div key={note.title}>
            <dt className="text-sm font-medium">{note.title}</dt>
            <dd className="text-sm leading-6 text-muted-foreground">{note.body}</dd>
          </div>
        ))}
      </dl>
    </section>
  );
}
